export default function Dialog(theme) {
  return {
    MuiDialog: {
      styleOverrides: {
        container: {
          opacity: 1,
          ...(window.env.isApp && {
            background: theme.palette.background.paper
          })
        },
        paper: {
          maxHeight: 'calc(100% - env(safe-area-inset-bottom) - env(safe-area-inset-top)) !important',
          backgroundColor: theme.palette.background.paper,
          boxShadow: theme.customShadows.z24
        },
        paperFullWidth: {
          width: '100%'
        },
        paperFullScreen: {
          '.MuiDialogActions-root': {
            paddingBottom: theme.spacing(4) // Évite le chevauchement sur la barre bottom iOS
          }
        }
      }
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          // marginTop: 'var(--safe-area-inset-top) !important',
          paddingBottom: 0,
          UserSelect: 'none !important'
        }
      }
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          display: 'flex',
          flexFlow: 'column nowrap',
          padding: theme.spacing(3)
        }
      }
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
          // Rules required to avoid squircle to be in front of MuiDialogActions container
          backgroundColor: theme.palette.background.paper,
          zIndex: 1
        }
      }
    }
  };
}
